import React from "react";
import { Button, Form, Input } from "antd";
import { useModal } from "../../cro/context/CroModalContext";
import { btnStyle } from "../../cro/styles/buttonStyles";
import { useTranslation } from "react-i18next";

interface ZipCodeProps {
  userZipCode: string | null;
  setUserZipCode: (zipCode: string) => void;
}

const ZipCode: React.FC<ZipCodeProps> = ({ userZipCode, setUserZipCode }) => {
  const { hideModal } = useModal();
  const { t } = useTranslation("cro");

  return (
    <Form
      layout="vertical"
      onFinish={async (values) => {
        setUserZipCode(values.zipCode);
        hideModal();
      }}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        margin: "0 auto",
      }}
    >
      <Form.Item
        initialValue={userZipCode || ""}
        label={null}
        name="zipCode"
        rules={[
          {
            validator: async (_, value) => {
              if (!value) {
                return Promise.reject(t("Please enter your zip code"));
              }
              if (value.length !== 5) {
                return Promise.reject(t("Zip code must be 5 digits"));
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <Input
          placeholder={t("Enter your zip code")}
          maxLength={5}
          size="large"
          style={{ width: "100%", margin: "1rem 0", textAlign: "center" }}
        />
      </Form.Item>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 4,
          marginTop: 5,
        }}
      >
        <Button htmlType="submit" style={btnStyle}>
          {t("Save")}
        </Button>
        <Button style={btnStyle} onClick={() => hideModal()}>
          {t("Close")}
        </Button>
      </div>
    </Form>
  );
};

export default ZipCode;
